export default __webpack_public_path__ + "static/media/TotemUso40.882fb6ab.jpg";